import { render } from "./Case.vue?vue&type=template&id=59d02164&ts=true"
import script from "./Case.vue?vue&type=script&lang=ts"
export * from "./Case.vue?vue&type=script&lang=ts"

import "./Case.vue?vue&type=style&index=0&id=59d02164&lang=scss"

import exportComponent from "D:\\a\\1\\s\\src\\WebUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__